module.exports = __webpack_public_path__ + "static/logo-55159456062375e3cd7a2ab2c342a56f.png";